import styled from '@emotion/styled';
import { UiTheme } from '@nykaa/payment-ui/src/@types';
import { getHexToRgba } from '@nykaa/payment-ui/src/common/helpers/getHexToRgba';


export const PincodeBottomSheetContentLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CustomTextLayout = styled.div`
  padding-bottom: 24px;
  padding-top: 8px;
`;

export const CustomSuccessButtonLayout = styled.div`
  padding-top: 0px;
  padding-bottom: 16px;
`;

export const CustomDismissButtonLayout = styled.div`
  padding-top: 12px;
  padding-bottom: 28px;
`;

export const BottomSheetWrapper = styled.div`
margin-top: 4px;
`;

export const NewBottomSheetWrapper = styled.div`
  margin-top: 4px;
  .new-bottom-sheet-title {
    padding: 8px 0 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .new-bottom-sheet-sub-title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-bottom: 16px;
  }
  .horizontal-separator {
    height: 1px;
    background: ${({ theme }: UiTheme) => getHexToRgba(theme?.colors?.textPrimary, 0.08)};
    width: calc(100vw);
    right: 20px;
    position: relative;
  }
  .new-button-wrapper {
    display: flex;
    gap: 2%;
    padding 16px 0;
  }
`;

export const SubtitleWrapper = styled.div`
margin-top: 8px;
`;

export const IconWrapper = styled.div`
margin-bottom: 8px;
`;

export const ButtonWrapper = styled.div`
margin-top: 24px;
display: flex;
gap: 2%;
margin-bottom: 16px;

// button:first-child {
//   flex-shrink: 2;
// }
`;

export const TrustNote = styled.div`
  display: flex;
  align-items: center;  
  p {
    margin-right: 8px;
  }
`;

export const ToastLayout = styled.div`
  display: flex;
`;
